import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { Preloader } from 'react-materialize';
import PaginationCustomized from './PaginationCustomized';

class QueryPagination extends Component {
  shouldComponentUpdate(nextProps) {
    const diffQueryCount   = this.props.queriesCount !== nextProps.queriesCount;
    const diffQueryLoading = this.props.queryLoading !== nextProps.queryLoading;

    return diffQueryCount || diffQueryLoading
  }

  renderLoader() {
    if (this.props.queryLoading) {
      return <Preloader size="small" />;
    }
  }

  calculatePageCount() {
    const queriesLength = this.props.queries.length;
    return Math.ceil(queriesLength / 10);
  }

  render() {
    const { queriesCount } = this.props;
    if (!queriesCount) return <div />;

    return (
      <div className="query-pagination" style={{ textAlign: 'center', marginTop: 15 }}>
        <PaginationCustomized
          items={queriesCount}
          maxButtons={5}
          onSelect={pageNum => this.props.getActiveQueryPageNum(pageNum)}
        />
      </div>
    );
  }
}

function mapStateToProps({
  pageCount,
  startDate,
  endDate,
  positionFilter,
  selectedPage,
  queriesCount,
  queryLoading,
  queries
}) {
  return {
    pageCount,
    startDate,
    endDate,
    positionFilter,
    selectedPage,
    queriesCount,
    queryLoading,
    queries
  };
}

export default connect(mapStateToProps, actions)(QueryPagination);



// WEBPACK FOOTER //
// ./src/components/Dashboard/QueryPagination.js